export function setNextShellLanguage(languageId: string) {
    // Inform the NEXT Shell about the current language
    if (typeof tmJSEvents != "undefined" && typeof tmJSEvents.languageChanged == "function") {
        tmJSEvents.languageChanged(languageId)
    }
}
